import { RolBasic } from 'src/app/models/roles-models/rol-basic.model';
import { LoginVerificationContact } from 'src/app/models/login-verification-model/login-verification-contact.model';

export class User {

    private companyInternalId: string;
    private editPermission: boolean;
    private email: string;
    private firstname: string;
    private internalId: string;
    private lastname: string;
    private password: string;
    private permissionList: RolBasic[];
    private loginVerificationContacts: LoginVerificationContact[];
    private userImage: string;
    private userImageName: string;
    private userImageRaw: string;
    private username: string;

    constructor(companyInternalId?: string,
                editPermission?: boolean,
                email?: string,
                firstname?: string,
                internalId?: string,
                lastname?: string,
                password?: string,
                permissionList?: RolBasic[],
                loginVerificationContacts?: LoginVerificationContact[],
                userImage?: string,
                userImageName?: string,
                userImageRaw?: string,
                username?: string) {
        this.companyInternalId = companyInternalId;
        this.editPermission = editPermission;
        this.email = email;
        this.firstname = firstname;
        this.internalId = internalId;
        this.lastname = lastname;
        this.password = password;
        this.permissionList = permissionList;
        this.loginVerificationContacts = loginVerificationContacts;
        this.userImage = userImage;
        this.userImageRaw = userImageRaw;
        this.username = username;
    }

    public get EditPermission() {
        return this.editPermission;
    }
    public get CompanyInternalId() {
        return this.companyInternalId;
    }
    public get Email() {
        return this.email;
    }
    public get Firstname() {
        return this.firstname;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get Lastname() {
        return this.lastname;
    }
    public get Password() {
        return this.password;
    }
    public get PermissionList() {
        return this.permissionList;
    }
    public get LoginVerificationContacts() {
        return this.loginVerificationContacts;
    }
    public get UserImage() {
        return this.userImage;
    }
    public get UserImagename() {
        return this.userImageName;
    }
    public get UserImageRaw() {
        return this.userImageRaw;
    }
    public get Username() {
        return this.username;
    }

    public set CompanyInternalId(companyInternalId) {
        this.companyInternalId = companyInternalId;
    }
    public set EditPermission(editPermission) {
        this.editPermission = editPermission;
    }
    public set Email(email) {
        this.email = email;
    }
    public set Firstname(firstname) {
        this.firstname = firstname;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set Lastname(lastname) {
        this.lastname = lastname;
    }
    public set Password(password) {
        this.password = password;
    }
    public set PermissionList(permissionList) {
        this.permissionList = permissionList;
    }
    public set LoginVerificationContacts(loginVerificationContacts) {
        this.loginVerificationContacts = loginVerificationContacts;
    }
    public set UserImage(userImage) {
        this.userImage = userImage;
    }
    public set UserImageName(userImageName) {
        this.userImageName = userImageName;
    }
    public set UserImageRaw(userImageRaw) {
        this.userImageRaw = userImageRaw;
    }
    public set Username(username) {
        this.username = username;
    }
}
